import '.a{display:grid;}.ssr-plugin'
import '.b{grid-template-columns:minmax(0, 1fr);}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import { styled, Style } from 'inlines'
import { useLoading } from '@based/sdk/react'
import { pages } from '@app/util/links'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { useTenantContext } from '@app/util/contexts/TenantContext'

export const LandingStoryCards = ({ style }: { style?: Style }) => {
  const isLoading = useLoading()
  const isMobile = useMediaQuery()
  const t = useTranslations()
  const { tenant } = useTenantContext()

  if (tenant?.stories.length === 0 && !isLoading) {
    return <div>{t.app.blogPage.noContent}</div>
  }

  return (
    <>
      {isLoading ? (
        <div>{t.app.blogPage.loading}</div>
      ) : (
        <styled.div className="a b c"
          style={{
            '@media (min-width: 800px)': {
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              '& > :nth-child(1)': {
                gridColumn: 'span 2',
              },
            },
            ...style,
          }}
        >
          {tenant?.stories.map((item, index) => (
            <BlogCard
              key={item.id}
              orientation={index === 0 && !isMobile ? 'horizontal' : 'vertical'}
              image={item.images?.[0]?.src}
              meta={new Date(item.publishedAt).toLocaleDateString()}
              title={item.title}
              to={pages.blog('verhalen', item.slug)}
              imageStyle={
                index === 0 && !isMobile
                  ? {
                      aspectRatio: '1/1',
                      width: 'auto',
                      maxHeight: '25rem',
                    }
                  : undefined
              }
              intro={index === 0 && !isMobile ? item.intro : undefined}
            />
          ))}
        </styled.div>
      )}
    </>
  )
}
